import React, { ReactElement } from 'react'

export const Layout1Top2Bottom: React.FC = (): ReactElement => (
    <div className='layout1Top2Bottom'>
        <svg viewBox='0 0 30 30'>
            <path className='dashboard-layout-outer-border' d='M28,2V28H2V2H28m2-2H0V30H30V0Z' />
            <line className='central-border-line' x1='15' y1='16' x2='15' y2='30' />
            <line className='central-border-line' y1='15' x2='30' y2='15' />
            <rect
                className='dashboard-background-2 dashboard-layout-entry-square'
                x='2'
                y='16'
                width='12'
                height='12'
            />
            <text className='dashboard-foreground-2 dashboard-layout-entry-text' transform='translate(6.2 24.74)'>
                2
            </text>
            <rect
                className='dashboard-background-3 dashboard-layout-entry-square'
                x='16'
                y='16'
                width='12'
                height='12'
            />
            <text className='dashboard-foreground-3 dashboard-layout-entry-text' transform='translate(20.2 24.74)'>
                3
            </text>
            <rect
                className='dashboard-background-1 dashboard-layout-entry-square'
                x='9'
                y='-5'
                width='12'
                height='26'
                transform='translate(23 -7) rotate(90)'
            />
            <text className='dashboard-foreground-1 dashboard-layout-entry-text' transform='translate(13.64 10.69)'>
                1
            </text>
        </svg>
    </div>
)
